$(document).ready(function() {
  $(".feature .atc-read-btn").on("click",function() {
  var find_parent= $(this).closest(".icon-details");
    find_parent.find(".desc").toggleClass("active");
    var txt = find_parent.find(".desc").is(':visible') ? 'Read More' : 'Read Less';
    $(this).text();
    
  });


   $(".tab-header-data .tab-heading").on("click",function() {
     $(".tab-heading").removeClass("active");
     $(this).addClass("active");
    var handle_attr=$(this).attr("tag-handle");
     $(".tab-inner-data").hide();
     $("#datas-"+handle_attr).show();
  });

  /* Product image popup */
 $(document).on('click','.featured-datas .featured-image',function(){
     var featuredImg=$(this).attr("data-img");
    $(".popup-pop-image").attr('src',featuredImg);
   $(".popup-open-box").addClass("open");
 
  });
       
   $(".close-popicon").on("click",function() {
    
    $(".popup-pop-image").attr('src','');
   $(".popup-open-box").removeClass("open");
 
  }); 



  $('.slideshow-items').hover(function() { changeSlide($(this)); });

  $(this).mousemove(function(e) {
    var x = e.clientX; var y = e.clientY;
    
    var x = e.clientX; var y = e.clientY;

    var imgx1 = $('.slideshow-items.active').offset().left;
    var imgx2 = $('.slideshow-items.active').outerWidth() + imgx1;
    var imgy1 = $('.slideshow-items.active').offset().top;
    var imgy2 = $('.slideshow-items.active').outerHeight() + imgy1;

    if ( x > imgx1 && x < imgx2 && y > imgy1 && y < imgy2 ) {
      $('#lens').show(); $('#result').show();
      imageZoom( $('.slideshow-items.active'), $('#result'), $('#lens') );
    } else {
      $('#lens').hide(); $('#result').hide();
    }

  });
  


function imageZoom( img, result, lens ) {

  result.width( img.innerWidth() ); result.height( img.innerHeight() );
  lens.width( img.innerWidth() / 2 ); lens.height( img.innerHeight() / 2 );

  result.offset({ top: img.offset().top, left: img.offset().left + img.outerWidth() + 10 });

  var cx = img.innerWidth() / lens.innerWidth(); var cy = img.innerHeight() / lens.innerHeight();

  result.css('backgroundImage', 'url(' + img.attr('src') + ')');
  result.css('backgroundSize', img.width() * cx + 'px ' + img.height() * cy + 'px');

  lens.mousemove(function(e) { moveLens(e); });
  img.mousemove(function(e) { moveLens(e); });
  lens.on('touchmove', function() { moveLens(); })
  img.on('touchmove', function() { moveLens(); })

  function moveLens(e) {
    var x = e.clientX - lens.outerWidth() / 2;
    var y = e.clientY - lens.outerHeight() / 2;
    if ( x > img.outerWidth() + img.offset().left - lens.outerWidth() ) { x = img.outerWidth() + img.offset().left - lens.outerWidth(); }
    if ( x < img.offset().left ) { x = img.offset().left; }
    if ( y > img.outerHeight() + img.offset().top - lens.outerHeight() ) { y = img.outerHeight() + img.offset().top - lens.outerHeight(); }
    if ( y < img.offset().top ) { y = img.offset().top; }
    lens.offset({ top: y, left: x });
    result.css('backgroundPosition', '-' + ( x - img.offset().left ) * cx  + 'px -' + ( y - img.offset().top ) * cy + 'px');
  }
}


function changeSlide(elm) {
  $('.slideshow-items').removeClass('active');
  $('.slideshow-items').eq( elm.index() ).addClass('active');
  $('.slideshow-thumbnails').removeClass('active');
  $('.slideshow-thumbnails').eq( elm.index() ).addClass('active');
}

  




  /*Accordions js */
   $(document).ready(function() {
   $(".accordion_head").click(function() {

    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      
        $(".accordion_head").removeClass("active");
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      
          $(this).removeClass("active");
    } else {
      $(this).next(".accordion_body").slideDown(300);
     
       
       $(this).addClass("active");
    }
  });
});



   

});
